// extracted by mini-css-extract-plugin
export var o_headboard1 = "headboard1-module--o_headboard1--920a7";
export var o_headboard1__actions = "headboard1-module--o_headboard1__actions--eb0f5";
export var o_headboard1__bg = "headboard1-module--o_headboard1__bg--e6533";
export var o_headboard1__container = "headboard1-module--o_headboard1__container--6fc67";
export var o_headboard1__desc = "headboard1-module--o_headboard1__desc--08e95";
export var o_headboard1__info = "headboard1-module--o_headboard1__info--5356c";
export var o_headboard1__subtitle = "headboard1-module--o_headboard1__subtitle--e0dc2";
export var o_headboard1__title = "headboard1-module--o_headboard1__title--800b9";